/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import axiosInstance from "./axios";

const POST = (url: string, data?: any, params?: any) => axiosInstance.post(url, data, { ...params });

export default POST;
